import styled from 'styled-components';

export default styled.img`
  width: ${props => props.theme.buttonHeight}px;
  margin: 3px 3px 0 0;
`;
